export default __webpack_public_path__ + "static/media/twitter-black.3ecc915f.svg";